import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import { ReactNode } from 'react';
import { useConfirmDeleteDialog } from './useConfirmDeleteDialog';

type Props = {
  title: string;
  children: ReactNode;
  /** Label of the destructive button, "Supprimer" by default. */
  confirmLabel?: string;
  onConfirm: () => Promise<unknown>;
  onClose: () => void;
};

export default function ConfirmDeleteDialog(props: Props) {
  const hook = useConfirmDeleteDialog(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="xs"
      fullWidth
      title={props.title}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: props.confirmLabel ?? 'Supprimer',
          color: 'error',
          onClick: hook.handleConfirm,
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}
        <Typography variant="body1">{props.children}</Typography>
        <Typography variant="body2">Cette action est irréversible.</Typography>
      </Stack>
    </Dialog>
  );
}
